import { useRef } from "react";

import { useIdentificationStatus } from "@/hooks/identificationStatusQueryOptions";
import {
  IdentificationStatusResponse,
  IdentificationStatusResponseKycStatus,
} from "@/services/model";

/** Not yet in the OpenAPI enum; backend returns this before onboarding is complete. */
export const KYC_STATUS_ONBOARDING_NOT_FINISHED = "ONBOARDING_NOT_FINISHED";

export const isKycVerified = (data: IdentificationStatusResponse): boolean =>
  data.isVerified === true &&
  data.kycStatus === IdentificationStatusResponseKycStatus.OK;

const needsIDCheck: (data: IdentificationStatusResponse) => boolean = (
  data,
) => {
  if (
    (data.kycStatus as string | undefined) ===
    KYC_STATUS_ONBOARDING_NOT_FINISHED
  ) {
    return false;
  }

  return !isKycVerified(data);
};

export const useNeedsIDCheck: () => boolean | undefined = () => {
  const staleTime = useRef(1000);
  const { data } = useIdentificationStatus(staleTime);

  if (data) {
    return needsIDCheck(data);
  }

  return undefined;
};
